(function() {
  function isElementVisible(element) {
    if (!element) {
      return false;
    }

    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function getTargetSlot() {
    var desktopSlot = document.querySelector('.header-6 .site-header__wishlist-slot');
    var mobileSlot = document.querySelector('.header-mobile .site-header__wishlist-slot');
    var desktopHeader = document.querySelector('.header-6');
    var mobileHeader = document.querySelector('.header-mobile');

    if (isElementVisible(desktopHeader) && desktopSlot) {
      return desktopSlot;
    }

    if (isElementVisible(mobileHeader) && mobileSlot) {
      return mobileSlot;
    }

    return mobileSlot || desktopSlot;
  }

  function placeVitalsWishlist() {
    var slot = getTargetSlot();
    var wrappers = document.querySelectorAll('.Vtl-WishlistHeaderWrapper');

    if (!slot || !wrappers.length) {
      return;
    }

    var wrapper = wrappers[0];

    for (var i = 1; i < wrappers.length; i++) {
      wrappers[i].remove();
    }

    if (!slot.contains(wrapper)) {
      slot.appendChild(wrapper);
    }

    document.querySelectorAll('.header-6 #AccessibleNav .Vtl-WishlistHeaderWrapper, .header-mobile #AccessibleNav .Vtl-WishlistHeaderWrapper').forEach(function(navWrapper) {
      navWrapper.remove();
    });
  }

  function getVariantIdFromProduct(productEl) {
    if (!productEl) {
      return null;
    }

    var link = productEl.querySelector('.Vtl-WishlistProduct__Link');
    if (!link || !link.href) {
      return null;
    }

    try {
      var url = new URL(link.href, window.location.origin);
      return url.searchParams.get('variant');
    } catch (error) {
      var match = link.href.match(/[?&]variant=(\d+)/);
      return match ? match[1] : null;
    }
  }

  function getWishlistVariantIds() {
    var ids = [];
    var seen = {};

    document.querySelectorAll('.Vtl-WishlistPage .Vtl-WishlistProduct').forEach(function(productEl) {
      var variantId = getVariantIdFromProduct(productEl);
      if (!variantId || seen[variantId]) {
        return;
      }
      seen[variantId] = true;
      ids.push(variantId);
    });

    return ids;
  }

  function getWishlistAddToCartButtonStyles() {
    var referenceButton = document.querySelector('.Vtl-WishlistPage .Vtl-WishlistProduct__AddToCart');

    if (referenceButton && referenceButton.getAttribute('style')) {
      return referenceButton.getAttribute('style');
    }

    return 'background-color: rgb(0, 0, 0); color: rgb(255, 255, 255);';
  }

  function createWishlistAddToCartButton() {
    var button = document.createElement('button');
    var label = document.createElement('span');

    button.type = 'button';
    button.className = 'Vtl-WishlistProduct__AddToCart';
    button.setAttribute('style', getWishlistAddToCartButtonStyles());
    label.className = 'Vtl-WishlistProduct__AddToCartText';
    label.textContent = 'Add to cart';
    button.appendChild(label);

    return button;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isIpad() {
    if (/iPad/.test(navigator.userAgent)) {
      return true;
    }

    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }

  function needsProductWishlistTouchFix() {
    return document.body.classList.contains('template-product') && (isMobileViewport() || isIpad());
  }

  function isProductWishlistRoot(element) {
    return !!element &&
      !element.classList.contains('Vtl-WishlistHeaderWrapper') &&
      typeof element.className === 'string' &&
      element.className.indexOf('Vtl-Wishlist') !== -1;
  }

  function stopTouchFromParentCapture(evt) {
    evt.stopPropagation();
  }

  function enableTouchWishlistControl(control) {
    if (!control || control.dataset.vitalsTouchGuard === 'true') {
      return;
    }

    control.dataset.vitalsTouchGuard = 'true';

    ['touchstart', 'touchmove'].forEach(function(eventName) {
      control.addEventListener(eventName, stopTouchFromParentCapture, { passive: eventName === 'touchmove' });
    });
  }

  function ensureProductWishlistSlot(container) {
    var slot = container.querySelector('.product-wishlist-slot');

    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'product-wishlist-slot';
      slot.setAttribute('aria-hidden', 'true');
      container.insertBefore(slot, container.firstChild);
    }

    return slot;
  }

  function relocateProductWishlist() {
    document.querySelectorAll('.prod-large-img').forEach(function(container) {
      var slot = ensureProductWishlistSlot(container);
      var zoomWrap = container.querySelector('[id^="FeaturedImageZoom-"]');

      if (!zoomWrap) {
        return;
      }

      zoomWrap.querySelectorAll('[class*="Vtl-Wishlist"]').forEach(function(wishlistEl) {
        if (!isProductWishlistRoot(wishlistEl) || slot.contains(wishlistEl)) {
          return;
        }

        slot.appendChild(wishlistEl);
      });
    });
  }

  function disableProductZoomOnTouch() {
    document.querySelectorAll('[id^="FeaturedImageZoom-"]').forEach(function(zoomWrap) {
      if (window.jQuery) {
        window.jQuery(zoomWrap).trigger('zoom.destroy');
      }

      zoomWrap.querySelectorAll('.zoomImg').forEach(function(zoomImage) {
        zoomImage.remove();
      });
    });
  }

  function fixProductWishlistTouches() {
    var selector = [
      '.product-wishlist-slot [class*="Vtl-Wishlist"] button',
      '.product-wishlist-slot [class*="Vtl-Wishlist"] a[href]',
      '.prod-large-img [class*="Vtl-Wishlist"] button',
      '.prod-large-img [class*="Vtl-Wishlist"] a[href]',
      '.product-single__photo [class*="Vtl-Wishlist"] button',
      '.product-single__photo [class*="Vtl-Wishlist"] a[href]',
      '.productSlider [class*="Vtl-Wishlist"] button',
      '.productSlider [class*="Vtl-Wishlist"] a[href]',
      '.grid-view_image [class*="Vtl-Wishlist"] button',
      '.grid-view_image [class*="Vtl-Wishlist"] a[href]'
    ].join(', ');

    document.querySelectorAll(selector).forEach(function(control) {
      if (control.closest('.Vtl-WishlistHeaderWrapper')) {
        return;
      }

      enableTouchWishlistControl(control);
    });
  }

  function initTouchProductWishlist() {
    if (!needsProductWishlistTouchFix()) {
      return;
    }

    if (isIpad()) {
      document.body.classList.add('is-ipad-device');
      document.documentElement.classList.add('is-ipad-device');
    }

    relocateProductWishlist();

    if (isMobileViewport()) {
      disableProductZoomOnTouch();
    }

    fixProductWishlistTouches();
  }

  function ensureWishlistAddToCartButtons() {
    var wishlistPage = document.querySelector('.Vtl-WishlistPage');

    if (!wishlistPage) {
      return;
    }

    wishlistPage.querySelectorAll('.Vtl-WishlistProduct').forEach(function(productEl) {
      if (productEl.querySelector('.Vtl-WishlistProduct__AddToCart')) {
        return;
      }

      if (!getVariantIdFromProduct(productEl)) {
        return;
      }

      productEl.appendChild(createWishlistAddToCartButton());
    });
  }

  function fetchCartJson() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      return response.json();
    });
  }

  function addVariantsToCart(variantIds) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: variantIds.map(function(variantId) {
          return {
            id: parseInt(variantId, 10),
            quantity: 1
          };
        })
      })
    }).then(function(response) {
      if (!response.ok) {
        return response.json().then(function(errorBody) {
          throw errorBody;
        });
      }
      return response.json();
    }).then(function() {
      return fetchCartJson();
    });
  }

  function openCartDrawerWithCart(cart) {
    if (window.theme && theme.CartHelpers && theme.CartHelpers.applyCartState) {
      theme.CartHelpers.applyCartState(cart, { openDrawer: true });
      return;
    }

    if (window.theme && theme.CartDrawer && typeof theme.CartDrawer.open === 'function') {
      theme.CartDrawer.open();
    }
  }

  function showCartError(errorBody) {
    var message = (errorBody && errorBody.description) ? errorBody.description : 'Unable to add item to cart.';

    if (window.theme && theme.CartHelpers && theme.CartHelpers.showCartError) {
      theme.CartHelpers.showCartError(message);
      return;
    }

    window.alert(message);
  }

  function setButtonLoading(button, isLoading) {
    if (!button) {
      return;
    }

    button.disabled = !!isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function handleSingleAdd(button) {
    var productEl = button.closest('.Vtl-WishlistProduct');
    var variantId = getVariantIdFromProduct(productEl);

    if (!variantId) {
      return;
    }

    if (!window.theme || !theme.CartHelpers || !theme.CartHelpers.fetchCartAdd) {
      return;
    }

    setButtonLoading(button, true);

    theme.CartHelpers.fetchCartAdd(variantId, 1, {
      skipSellingPlan: true
    }).then(function(cart) {
      openCartDrawerWithCart(cart);
    }).catch(function(errorBody) {
      showCartError(errorBody);
    }).finally(function() {
      setButtonLoading(button, false);
    });
  }

  function handleAddAll(button) {
    var variantIds = getWishlistVariantIds();

    if (!variantIds.length) {
      return;
    }

    setButtonLoading(button, true);

    addVariantsToCart(variantIds).then(function(cart) {
      openCartDrawerWithCart(cart);
    }).catch(function(errorBody) {
      showCartError(errorBody);
    }).finally(function() {
      setButtonLoading(button, false);
    });
  }

  function handleWishlistCartClick(evt) {
    var addButton = evt.target.closest('.Vtl-WishlistProduct__AddToCart');
    var addAllButton = evt.target.closest('.Vtl-WishlistAddAllToCart');

    if (!addButton && !addAllButton) {
      return;
    }

    if (!document.querySelector('.Vtl-WishlistPage')) {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    if (addButton && !addButton.disabled) {
      handleSingleAdd(addButton);
      return;
    }

    if (addAllButton && !addAllButton.disabled) {
      handleAddAll(addAllButton);
    }
  }

  function initVitalsWishlist() {
    placeVitalsWishlist();
    ensureWishlistAddToCartButtons();
    initTouchProductWishlist();
  }

  var touchInitTimer = null;

  function scheduleTouchProductWishlist() {
    if (!needsProductWishlistTouchFix()) {
      return;
    }

    if (touchInitTimer) {
      window.clearTimeout(touchInitTimer);
    }

    touchInitTimer = window.setTimeout(initTouchProductWishlist, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVitalsWishlist);
  } else {
    initVitalsWishlist();
  }

  window.setTimeout(initVitalsWishlist, 500);
  window.setTimeout(initVitalsWishlist, 1500);
  window.addEventListener('resize', function() {
    placeVitalsWishlist();
    initTouchProductWishlist();
  });

  if (window.jQuery) {
    window.jQuery(document).on('init reInit afterChange', '.productSlider', scheduleTouchProductWishlist);
  }

  if (window.MutationObserver) {
    new MutationObserver(function() {
      initVitalsWishlist();
      scheduleTouchProductWishlist();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('click', handleWishlistCartClick, true);
})();
